import { Link, useLocation } from 'react-router-dom'

const NavLink = ({ children, className, to, isOutLink = false }) => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const ljhdid = searchParams.get('ljhdid')

  const toHref = () => {
    if (isOutLink) {
      return to
    } else {
      return `${to !== '/' ? `${to}.html${ljhdid ? `?ljhdid=${ljhdid}` : ''}` : '/'}`
    }
  }

  return (
    <Link target="_blank" className={className} to={toHref()}>
      {children}
    </Link>
  )
}

export default NavLink
